export default __webpack_public_path__ + "static/media/breadcrumb-bg-mob.922ae046.webp";